export const assetConstants = {
  ASSET_HAS_ERRORED: 'ASSET_HAS_ERRORED',
  ASSET_IS_LOADING: 'ASSET_IS_LOADING',
  ASSET_FETCH_DATA_SUCCESS: 'ASSET_FETCH_DATA_SUCCESS',
  ASSET_REQUEST_REMOVE_REQUEST: 'ASSET_REQUEST_REMOVE_REQUEST',
  ASSET_REQUEST_REMOVE_SUCCESS: 'ASSET_REQUEST_REMOVE_SUCCESS',
  ASSET_REQUEST_REMOVE_FAILURE: 'ASSET_REQUEST_REMOVE_FAILURE',
};
